'use client';

import * as React from 'react';

import type { ListingBySlugPartial } from '@utils/imperative-node-queries';

import { ReviewsProvider } from './reviews-context';
import { ReviewsModal } from './reviews-modal';
import { ReviewsSection } from './reviews-section';

interface ListingReviewsSectionProps {
  listing: ListingBySlugPartial;
}

export const ListingReviewsSection: React.FC<ListingReviewsSectionProps> = ({
  listing,
}) => {
  return (
    <ReviewsProvider listingId={listing.id}>
      {listing.reviewsAverageRating && listing.reviewsCount ? (
        <ReviewsModal
          reviewsAverageRating={listing.reviewsAverageRating}
          reviewsCount={listing.reviewsCount}
          reviewSummary={listing.reviewSummary || undefined}
        />
      ) : null}
      <ReviewsSection
        averageRating={listing.reviewsAverageRating || 0}
        reviewsCount={listing.reviewsCount || 0}
        airbnbUrl={listing.airbnbUrl}
        vrboUrl={listing.vrboUrl}
        reviewSummary={listing.reviewSummary || undefined}
      />
    </ReviewsProvider>
  );
};
